import { render } from '../../core/shell.js';
import { S, UI, save } from '../../core/store.js';
import { closeModal, toast } from '../../core/ui.js';
import { off, uid, val } from '../../core/util.js';
import { lockInModal } from '../projects/create.js';
import { DOCS } from './model.js';
import { dealModal, docDrawer, docModal } from './view.js';

export const actions={
stab(el){UI.stab=el.dataset.s;render()},
deal(el){const d=S.deals.find(x=>x.id===el.dataset.id);if(d)dealModal(d)},
dealnew(el){dealModal(null,el.dataset.s)},
dealsave(){
  const name=val('dl-name');if(!name){toast('Give the deal a name');return}
  const id=val('dl-id');let d=S.deals.find(x=>x.id===id);const stage=val('dl-stage');
  const data={name,client:val('dl-client')||'No client',amt:Number(val('dl-amt'))||0,close:val('dl-close')||off(30),owner:val('dl-owner')||S.me};
  if(d){const was=d.stage;Object.assign(d,data,{stage});save();closeModal();render();if(stage==='won'&&was!=='won'&&!d.pid)lockInModal(d)}
  else{d={id:uid(),stage};Object.assign(d,data);S.deals.push(d);save();closeModal();render();if(stage==='won')lockInModal(d)}
 },
dealdel(el){S.deals=S.deals.filter(d=>d.id!==el.dataset.id);save();closeModal();render()},
docnew(el){docModal(el.dataset.t)},
docsave(el){
  const t=el.dataset.t,dt=DOCS[t];const title=val('dc-title');if(!title){toast('Add a title');return}
  const nums=S.docs.filter(x=>x.type===t).map(x=>parseInt(x.no.replace(/\D/g,''),10)||0);const n=Math.max(0,...nums)+1;
  const x={id:uid(),type:t,no:dt.pre+String(n).padStart(4,'0'),client:val('dc-client'),title,amt:Number(val('dc-amt'))||0,status:'Draft',date:off(0),due:t==='invoice'?off(S.settings.terms):null};
  S.docs.push(x);save();closeModal();toast('Created '+x.no);render();
 },
docopen(el){const x=S.docs.find(d=>d.id===el.dataset.id);if(x)docDrawer(x)},
paytab(el){UI.paytab=el.dataset.t;const x=S.docs.find(d=>UI.modal&&UI.modal.title===d.no);if(x)docDrawer(x)},
markpaid(el){const x=S.docs.find(d=>d.id===el.dataset.id);x.status='Paid';save();closeModal();render();toast(x.no+' marked as paid')},
remind(el){const x=S.docs.find(d=>d.id===el.dataset.id);toast('Reminder queued for '+x.no)},
copylink(){toast('Payment link copied (demo)')}
};

export const changes={
docstatus(el){const x=S.docs.find(d=>d.id===el.dataset.id);x.status=el.value;save();render()}
};
